module.exports = __webpack_public_path__ + "static/media/Vecteezy_Register_Image.987cfa43.png";